import { useTranslation } from "react-i18next";

import { IconLogin } from "@/components/icons";
import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";

import useModalRouter from "@/hooks/useModalRouter";

const LoginModalBtn = () => {
  const { t } = useTranslation();
  const { openModal } = useModalRouter();

  return (
    <>
      <button
        className="group z-10 flex cursor-pointer items-center gap-2 px-3 py-2"
        onClick={() => openModal([MODAL_ROUTES.AUTH, MODAL_ROUTES.AUTH_LOGIN])}
      >
        <IconLogin className="size-6 stroke-[#919090] transition-colors group-hover:stroke-white" />
        <p className="text-[1rem] leading-[1.5rem] text-[#919090] transition-colors group-hover:text-white">
          {t("Actions.enter")}
        </p>
      </button>
    </>
  );
};

export default LoginModalBtn;
